export default __webpack_public_path__ + "static/media/NamesAlbumCover3000x3000.882ff2d6.jpg";